export function fetchPhysicalStores(config, lat, lng) {
    return new Promise(function (resolve, reject) {
        var xobj = new XMLHttpRequest();
        var storeLocatorLangId = langId == '-50'  ? '-1' : langId;
        var url = window.location.origin + '/wcs/resources/store/' + config.data.storeId + '/storelocator/product/latitude/' + lat + '/longitude/' + lng + '/' + config.data.frame.upc + "?langId="+ storeLocatorLangId;
        xobj.overrideMimeType("application/json");
        // the json must be in public folder 
        xobj.open('GET', url, true);
        xobj.onload = function () {
            if (xobj.readyState === 4 && (xobj.status === 200 || xobj.status === 0)) {
                resolve(JSON.parse(xobj.responseText))
            } else if (xobj.readyState === 4 && xobj.status === 503) {
                resolve(null);
            } else {
                reject({
                    status: xobj.status,
                    statuxText: xobj.statusText
                })
            }
        }
        xobj.onerror = function () {
            reject({
                status: xobj.status,
                statusText: xobj.statusText
            })
        }
        xobj.send(null);
    })
}





